import { render, staticRenderFns } from "./swipeBox.vue?vue&type=template&id=f6aa33ec&scoped=true&"
import script from "./swipeBox.vue?vue&type=script&lang=js&"
export * from "./swipeBox.vue?vue&type=script&lang=js&"
import style0 from "./swipeBox.vue?vue&type=style&index=0&id=f6aa33ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6aa33ec",
  null
  
)

export default component.exports